export const RegistrationType = {
    manual: 'manual',
    sendLink: 'sendLink',
};
